import { MdOutlineEmail } from "react-icons/md";
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import PaymentsLogos from "./PaymentsLogos";
import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [isSubscribed, setIsSubscribed] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  
  const handleSubmit = (e) => {
    e.preventDefault(); 
    setIsSubscribed(true); 
    
    
    
    setTimeout(() => {
      setIsSubscribed(false);
    }, 3000);
  };

  return (
    <div>
      <div className="flex flex-wrap justify-between items-center p-5 bg-black mt-10 rounded-3xl w-full sm:w-[600px] sm:max-w-none sm:h-auto sm:rounded-3xl sm:justify-between sm:p-10 xsm:aspect-square xsm:w-full xsm:min-h-[300px]">
        <div className="bolded text-3xl xsm:text-4xl text-white mb-10 max-w-[600px] sm:mb-0 sm:max-w-full">
          STAY UP TO DATE ABOUT OUR <br /> LATEST OFFERS
        </div>
        <form 
          onSubmit={handleSubmit} 
          className="flex flex-col gap-3 w-full sm:w-auto items-center"
        >
          <div className="rounded-3xl bg-white p-2 flex w-full sm:w-auto">
            <MdOutlineEmail size={20} />
            <input 
              className="text-black outline-none ml-2 w-full sm:w-[500px] sm:text-sm" 
              placeholder="Enter your email address"
              type="email" 
              required 
            />
          </div>
          <button 
            type="submit" 
            className="rounded-3xl bg-white p-2 text-black text-center w-full sm:w-[300px] sm:text-sm"
          >
            Subscribe to Newsletter
          </button>
        
          {isSubscribed && (
            <p className="text-white text-sm mt-2">Thanks for subscribe</p>
          )}
        </form>
      </div>

      <footer>
        <div className="flex flex-wrap justify-between mt-10 gap-10">
          <div id="1" className="flex-grow w-full lg:w-auto flex flex-col gap-10 ml-5 lg:ml-10">
            <h1 className="bolded text-3xl">SHOP.CO</h1>
            <p className="max-w-72 sm:max-w-full sm:text-left">
              We have clothes that suits your style and<br></br> which you're proud to wear. From women to men.
            </p>
            <div className="flex gap-5">
              <FaXTwitter size={25} />
              <FaFacebook size={25} />
              <FaInstagram size={25} />
              <FaGithub size={25} />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5 w-full sm:grid-cols-2 lg:flex lg:flex-grow lg:w-auto">
            <div id="2" className="w-full flex flex-col gap-2 items-center lg:items-start text-xs sm:text-sm">
              <h1 className="font-semibold text-base sm:text-lg">Company</h1>
              <ul className="flex flex-col gap-1 sm:gap-2">
                <li><Link to="/About" onClick={scrollToTop}>About</Link></li>
                <li><Link to="/shop" onClick={scrollToTop}>Features of SHOP.CO</Link></li>
                <li><Link to="/shop" onClick={scrollToTop}>Works</Link></li>
                <li><Link to="/About" onClick={scrollToTop}>Career</Link></li>
              </ul>
            </div>

            <div id="3" className="w-full flex flex-col gap-2 items-center lg:items-start text-xs sm:text-sm">
              <h1 className="font-semibold text-base sm:text-lg">Help</h1>
              <ul className="flex flex-col gap-1 sm:gap-2">
                <li><Link to="/Contact" onClick={scrollToTop}>Customer Support</Link></li>
                <li><Link to="/orders" onClick={scrollToTop}>Delivery Details</Link></li>
                <li>Terms & Conditions</li>
                <li>Privacy Policy</li>
              </ul>
            </div>

            <div id="4" className="w-full flex flex-col gap-2 items-center lg:items-start text-xs sm:text-sm">
              <h1 className="font-semibold text-base sm:text-lg">FAQ</h1>
              <ul className="flex flex-col gap-1 sm:gap-2">
                <li><Link to="/profile" onClick={scrollToTop}>Account</Link></li>
                <li><Link to="/orders" onClick={scrollToTop}>Manage Deliveries</Link></li>
                <li><Link to="/orders" onClick={scrollToTop}>Orders</Link></li>
                <li>Payments</li>
              </ul>
            </div>

            <div id="5" className="w-full flex flex-col gap-2 items-center lg:items-start text-xs sm:text-sm">
              <h1 className="font-semibold text-base sm:text-lg">Resources</h1>
              <ul className="flex flex-col gap-1 sm:gap-2">
                <li >Free eBooks</li>
                <li >Development Tutorial</li>
                <li >How to - Blog</li>
                <li >Youtube Playlist</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-10 gap-y-5 border-t-4 items-center flex-wrap">
          <div className="flex-grow text-center md:text-left">
            <a className="text-blue-800 ml-5" href="#"> Copyright © 2025 </a>
          </div>
          <div className="w-fit">
            <PaymentsLogos />
          </div>
        </div>
      </footer>
    </div>
  );
}
